/* RESPONSIBLE TEAM: team-frontend-tech */
import BlockSerializer from './block';

const OPTIONAL_BLOCK_ATTRIBUTES = ['align', 'style', 'trackingLinkUrl'];

export default BlockSerializer.extend({
  optionalAttributes: OPTIONAL_BLOCK_ATTRIBUTES,
});
